// PaymentServicesDialog.jsx
import React from "react";
import CustomDialog from "../../common/CustomDialog";

export default function PaymentServicesDialog({
    open,
    onClose,
    paymentservice,
    selectedServices,
    handleServiceChange,
    handleSave,
    payoutMode,
    setPayoutMode,
}) {
    const isPayoutSelected = selectedServices.includes("PAYOUT");

    return (
        <CustomDialog open={open} onClose={onClose} title="Payment Services">
            <div className="container py-2">
                <div className="row">
                    {paymentservice?.map((service) => (
                        <div
                            key={service.paymentTypeId}
                            className="col-6 col-md-4 form-check mb-2"
                        >
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id={`service-${service.paymentTypeId}`}
                                value={service.paymentService}
                                checked={selectedServices.includes(service.paymentService)}
                                onChange={handleServiceChange}
                            />
                            <label
                                htmlFor={`service-${service.paymentTypeId}`}
                                className="form-check-label"
                            >
                                {service.paymentService}
                            </label>
                        </div>
                    ))}

                    {/* Show dropdown if Payout selected */}
                    {isPayoutSelected && (
                        <div className="col-12 mt-3">
                            <label className="fw-bold">Payout Active For</label>
                            <select
                                className="form-select mt-1"
                                value={payoutMode}
                                onChange={(e) => setPayoutMode(e.target.value)}
                            >
                                <option value="">-- Select Mode --</option>
                                <option value="PANEL">PANEL</option>
                                <option value="API">API</option>
                                <option value="BOTH">BOTH</option>
                            </select>
                        </div>
                    )}

                    <div className="col-12 mt-3 d-flex justify-content-end">
                        <button className="btn btn-success px-4" onClick={handleSave}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </CustomDialog>
    );
}